import { render } from "./SideCaution.vue?vue&type=template&id=6e4cb0f0&scoped=true"
import script from "./SideCaution.vue?vue&type=script&lang=js"
export * from "./SideCaution.vue?vue&type=script&lang=js"

import "./SideCaution.vue?vue&type=style&index=0&id=6e4cb0f0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4cb0f0"]])

export default __exports__